import { render, staticRenderFns } from "./loginPopup.vue?vue&type=template&id=506b00e8&scoped=true"
import script from "./loginPopup.vue?vue&type=script&lang=js"
export * from "./loginPopup.vue?vue&type=script&lang=js"
import style0 from "./loginPopup.vue?vue&type=style&index=0&id=506b00e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b00e8",
  null
  
)

export default component.exports